module.exports = __webpack_public_path__ + "img/tmp-patients-status-4.73b9eb11.svg";